<template>
    <main class="main">
        <div class="main__page">
            <div class="card">
                <div class="card__detail">
                    <span v-if="loading">
                        {{ $t('common.loading') }}
                    </span>
                    <form class="form customer_form_container" @submit.prevent="submitForm" v-if="!loading">
                        <div class="customer_form_container__col">
                            <div class="form__field form__field_all">
                                <label class="form__field-label" :for="$t('customers.agency')">{{ $t('customers.agency') }}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.agency.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.agency.required">
                                    {{ $t('customers.errors.agency_required') }}
                                </div>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.first_name')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.first_name.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.first_name.required">
                                    {{ $t('customers.errors.first_name_required') }}
                                </div>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.last_name')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.last_name.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.last_name.required">
                                    {{ $t('customers.errors.last_name_required') }}
                                </div>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.address')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.address.$model"/>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.vat_number')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.vat_number.$model"/>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.city')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.city.$model"/>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.email')}}</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.email.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.email.email">
                                    {{ $t('customers.errors.email_malformed') }}
                                </div>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.email')}} 2</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.email2.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.email2.email">
                                    {{ $t('customers.errors.email_malformed') }}
                                </div>
                            </div>
                            <div class="form__field form__field_all">
                                <label class="form__field-label">{{$t('customers.email')}} 3</label>
                                <input type="text" class="form__field-input" v-model.trim="$v.form.email3.$model"/>
                                <div class="field__validator_error" v-if="submitted && !$v.form.email3.email">
                                    {{ $t('customers.errors.email_malformed') }}
                                </div>
                            </div>

                        </div>

                        <div class="customer_form_container__col customer_form_container__sedi">
                            <h3>Aggiungi una sede</h3>
                            Indirizzo: <input class="form__field" type="text" v-model="sede.indirizzo">
                            Luogo: <input class="form__field" type="text" v-model="sede.luogo">
                            <button class="btn" type="button" @click="addSede()">Aggiungi Sede</button>


                            <h3>Elenco sedi</h3>
                            <div class="customer_form_container__sedi__table"
                                 v-for="(sede, index) in form.sedi" v-bind:key="index">
                                <div class="customer_form_container__sedi__table__item">
                                    {{ sede.indirizzo }}
                                </div>
                                <div class="customer_form_container__sedi__table__item">
                                    {{ sede.luogo }}
                                </div>
                                <div class="customer_form_container__sedi__table__item">
                                    <button class="btn btn-small btn-red" type="button" @click="removeSede(index)">
                                        Rimuovi
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form__field">
                            <button type="submit" class="btn" :disabled="loading">
                                <span v-if="loading">{{ $t('common.loading') }}</span> <span v-if="!loading">
                                    <span v-if="$route.params.id == 'new'">{{ $t('common.add') }}</span>
                                    <span v-if="$route.params.id != 'new'">{{ $t('common.save') }}</span>
                                </span>
                            </button>
                            <button type="button" @click="modalDeleteOpen = true" class="btn form__field-btn" :disabled="loading">
                                <span v-if="loading">{{ $t('common.loading') }}</span>
                                <span v-if="!loading">
                                    {{ $t('common.delete') }}
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <alert-modal v-model="showError" v-bind:title="$t('customers.alert.error.generic.title')" v-bind:text="$t('customers.alert.error.generic.text')"></alert-modal>
        <confirm-modal v-model="modalDeleteOpen" v-bind:title="$t('customers.alert.delete.title')" v-bind:text="$t('customers.alert.delete.text')" @result="confirmDelete($event)"></confirm-modal>
    </main>
</template>
<script>
    import {required, email} from 'vuelidate/lib/validators'
    import AlertModal from "../../components/AlertModal"
    import ConfirmModal from "../../components/ConfirmModal"

    export default {
        name: 'customer-form',
        components: {AlertModal,ConfirmModal},
        mounted() {
            this.init();
        },
        data() {
            return {
                user: null,
                showError: false,
                submitted: false,
                error: '',
                loading: false,
                modalDeleteOpen: false,
                sede: {
                    indirizzo: '',
                    luogo: ''
                },
                form: {
                    agency: '',
                    first_name: '',
                    last_name: '',
                    address: '',
                    vat_number: '',
                    city: '',
                    email: '',
                    email2: '',
                    email3: '',
                    sedi: []
                }
            }
        },
        // gestione della validazione
        validations: {
            form: {
                agency: {
                    required
                },
                first_name: {
                    required
                },
                last_name: {
                    required
                },
                address: {},
                vat_number: {},
                city: {},
                email: { email },
                email2: {  email },
                email3: {  email }
            }
        },
        methods: {
            // inizializzo il tutto
            init() {
                // se id è new allora prendo i dati dell'utente
                // in caso di errore l'utente non ha i permessi
                // torno indietro
                if (this.$route.params.id !== 'new') {
                    this.loading = true;
                    this.api.customers.getSingle(this.$route.params.id)
                        .then((u) => {
                            // assegno nella form i dati dell'utentes
                            u.sedi = u.sedi || "[]";
                            u.sedi = JSON.parse(u.sedi);
                            Object.assign(this.form, u);
                            this.loading = false;
                        })
                        .catch(() => {
                            // in caso di errore, visualizzo l'errore
                            // e torno indietro
                            this.showError = true;
                            this.$watch('showError', () => {
                                if (!this.showError) {
                                    this.$router.back();
                                }
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            submitForm() {
                this.$v.$touch();
                this.submitted = true;
                this.error = '';
                this.loading = true;
                // controllo la validità della form
                // ci sarà un controllo anche lato server
                if (!this.$v.$invalid) {
                    this.loading = true;
                    let data =  {...this.form};
                    data.sedi = data.sedi || [];
                    this.api.customers.save(this.form, this.$route.params.id)
                        .then(() => {
                            this.toast.success();
                            this.$router.push({ path: '/customers' });
                        })
                        .catch((e) => {
                            this.toast.error(this.$t(`customers.errors.${e.error}`));
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                } else {
                    this.loading = false;
                }
            },
            confirmDelete(e) {
                if(e) {
                    this.loading = true;
                    this.modalDeleteOpen = false;
                    this.api.customers.delete(this.$route.params.id)
                        .then(() => {
                            this.toast.success();
                            this.$router.push({ path: '/customers' });
                        })
                        .catch((e) => {
                            this.toast.error(this.$t(`customers.errors.${e.error}`));
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            },
            addSede() {
                this.form.sedi = this.form.sedi || [];
                this.form.sedi.push({
                    indirizzo: this.sede.indirizzo,
                    luogo: this.sede.luogo
                });
                this.sede.indirizzo = "";
                this.sede.luogo = "";
            },
            removeSede(index) {
                if(confirm(`Eliminare questa sede? L'operazione è irreversibile.`)) {
                    this.form.sedi.splice(index, 1);
                }
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    @import './src/scss/form';

    .customer_form_container {
        display: flex;
        flex-wrap: wrap;

        &__col {
            width: 49%;
        }

        &__sedi {
            h3 {
                font-size: 20px;
                padding: 20px 0 20px 0;

            }
            &__table {
                display: flex;
                flex-wrap: wrap;
                &__item {
                    width: 33%;
                    margin: 5px 0;
                    padding: 10px;
                    border-bottom: 1px solid lightgrey;
                }
            }
        }

        .btn-small {
            font-size: 12px !important;
            padding: 5px 6px;
        }

        .btn-red {
            background: $red;
            color: $white;
        }
    }
</style>
